let selectors = {
  button: document.querySelector('.searchUnit__trigger'),
  drop: document.querySelector('.searchUnit__drop')
};


const watchSearchEvents = () => {


  $(document).mouseup(function(e) {

    let container = $(".searchUnit__drop");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
      selectors.drop.classList.remove('searchUnit__drop--active');
    }

  });

}

const Search = () => {
  selectors.button.addEventListener('click', () => {
    selectors.drop.classList.add('searchUnit__drop--active');
    watchSearchEvents();
  });
};

export default Search;


// WEBPACK FOOTER //
// ./src/js/app/components/Search.js